/* eslint-disable no-unused-vars */
import '../Projects.css';
import { ALLOTMENT_IDS, TEMPLATE_TYPE_NAME } from '../../globalVariable/typeProject';
import { addBuildingSiteIds } from '../../../app/projects/LifeCycle/LifeCycleTab';
import { getColorFromString } from '../../services/colors/getColor';
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HistogramVignetteComponent } from '@photocarbone/nooco-ui';

const ResponsiveBarGraph = (dat) => {
  const [graphData, setGraphData] = useState({});
  const [keys, setKeys] = useState([]);
  const [total, setTotal] = useState(1);
  const {
    allGroups,
    isRe2020,
    selectedFilterLot,
    fullScreen,
    sortedBy,
    selectedZoneIdForGraph,
    graphToFullScreen,
  } = dat;

  const parsedZones = useSelector((state) => state.projects.parsedProject.zones);
  const { currentProject, globalDataInstance } = useSelector(
    (state) => state.projects
  );
  const [surfaceRef, setSurfaceRef] = useState(0);
  const [isGraphEmpty, setIsGraphEmpty] = useState(true);
  const { t } = useTranslation();
  useEffect(() => {
    setMasterDatas();

    let reformatDatas = [];
    let keys = [];

    const { validZonesIds, referenceArea } = addBuildingSiteIds(
      selectedZoneIdForGraph,
      parsedZones,
      currentProject.area
    );

    setSurfaceRef(referenceArea);

    if (dat.structureGraph) {
      dat.structureGraph.forEach((equipment) => {
        let sheet;

        if (validZonesIds.includes(equipment.sheets.ProjectSheet.ZoneId)) {
          sheet = equipment.sheets;
        }
        if (!sheet || sheet.length === 0) {
          return;
        }

        let match = sheet.ProjectSheet?.AllotmentNodes.find(
          (node) => node.AllotmentId === 1 && equipment['0'] === node.id
        );

        if (match) {
          if (dat.level !== 0 && dat.currentAllotment.id === 1) {
            match = equipment.details.find((ele) => ele.id === equipment[dat.level]);
          }

          if (
            (dat.currentAllotment.id === 2 || dat.currentAllotment.id === 34) &&
            typeof dat.level === 'number'
          ) {
            match =
              equipment.details[equipment.details.length - 1 - (dat.level + 1)];
          }

          const parent =
            dat.currentAllotment.id !== 1 && typeof dat.level === 'string'
              ? dat.currentAllotment.AllotmentNodes.find(
                  (node) => node.id === equipment.details[0].ParentId
                )
              : (dat.currentAllotment.id === 2 || dat.currentAllotment.id === 34) &&
                typeof dat.level !== 'string'
              ? equipment.details[equipment.details.length - dat.level - 1]
              : dat.currentAllotment.AllotmentNodes.find(
                  (node) => node.id === match.ParentId
                );

          keys = [...keys, match?.name];

          let exist = reformatDatas.find((el) => el.name === parent?.name);

          if (parent && match) {
            const result = computeResult(
              sheet,
              dat.project.refUnit,
              dat.currentProject.ddv,
              equipment,
              surfaceRef,
              sortedBy
            );

            if (exist) {
              reformatDatas = reformatDatas.filter((el) => el.name !== parent.name);

              exist = {
                ...exist,
                [match.name]: exist[match.name]
                  ? exist[match.name] + result
                  : result,
                [`${match.name}Color`]: getColorFromString(match.name),
                [`${match.name}Id`]: match.id.toString(),
              };

              reformatDatas = [...reformatDatas, exist];
            } else {
              let object = {
                name: parent.name,
                [match.name]: result,
                [`${match.name}Color`]: getColorFromString(match.name),
                [`${match.name}Id`]: match.id.toString(),
              };

              reformatDatas = [...reformatDatas, object];
            }
          }
        }
      });

      reformatDatas = compressData(
        reformatDatas.sort(function (a, b) {
          let aSum = 0;
          let bSum = 0;

          for (let i in a) {
            if (typeof a[i] === 'number') {
              aSum += a[i];
            }
          }

          for (let j in b) {
            if (typeof b[j] === 'number') {
              bSum += b[j];
            }
          }

          return bSum - aSum;
        }),
        'name',
        t
      );

      if (reformatDatas.length > 0) {
        setIsGraphEmpty(false);
      } else {
        setIsGraphEmpty(true);
      }

      let formatData = [];

      let tempTotal = 0;

      reformatDatas.map((bar) => {
        let formatObject = {};

        for (const [key, value] of Object.entries(bar)) {
          if (typeof value === 'number') {
            formatObject = { ...formatObject, [key]: value };
            tempTotal += Number(value);
          } else {
            formatObject = { ...formatObject, [key]: value };
          }
        }

        formatData = [...formatData, formatObject];
      });

      let conditionToKnowIfProjectIsStatic =
        dat.project.templateType === TEMPLATE_TYPE_NAME.EPCM ||
        dat.project.isAcvDynamic === false ||
        dat.project.isStaticCarbon;

      let total = [
        TEMPLATE_TYPE_NAME.BBCA,
        TEMPLATE_TYPE_NAME.GLOBAL_MONITORING,
      ].includes(dat.project.templateType)
        ? dat.project.staticAcv
        : conditionToKnowIfProjectIsStatic &&
          dat.currentAllotment.id === ALLOTMENT_IDS.RE2020
        ? dat.project.dynamicRe2020Acv
        : dat.currentAllotment.id === ALLOTMENT_IDS.RE2020
        ? dat.project.dynamicRe2020Acv
        : conditionToKnowIfProjectIsStatic
        ? dat.project.staticAcv
        : dat.project.dynamicAcv;

      const denominator = surfaceRef ? surfaceRef : 1;

      setTotal(dat.project.refUnit === 'total' ? total : total / denominator);

      let filteredData = [];

      dat.structureGraph.forEach((data) => {
        let parent = data.details[data.details.length - 1];

        if (selectedFilterLot.find((el) => el.label === parent.name)) {
          let current;

          if (dat.currentAllotment.id !== 1) {
            if (typeof dat.level === 'number') {
              const index = data.details.length - dat.level;

              parent = data.details[index - 1];
            } else {
              parent = data.details[1];
            }

            current = formatData.find((el) => el.name === parent.name);
          } else {
            current = formatData.find(
              (el) => el.name === data.details[Number(dat.level) + 1].name
            );
          }

          if (!current) {
            const otherColumn = formatData.find(
              (el) => el.name === t('APP.REPORT.OTHERS', { defaultValue: 'Autres' })
            );

            parent =
              dat.currentAllotment.id === 1
                ? data.details[Number(dat.level) + 1]
                : parent;

            if (otherColumn && otherColumn[data.details[0].name] && parent) {
              if (filteredData.find((el) => el?.name === parent?.name)) {
                const indexCurr = filteredData.findIndex(
                  (el) => el?.name === parent?.name
                );

                if (indexCurr) {
                  filteredData[indexCurr] = {
                    ...filteredData[indexCurr],
                    [data.details[0].name]: otherColumn[data.details[0].name],
                    [`${data.details[0].name}Color`]: getColorFromString(
                      data.details[0].name
                    ),
                    [`${data.details[0].name}Id`]: data.details[0].id.toString(),
                  };
                }

                return;
              } else {
                current = {
                  name: parent.name,
                  [data.details[0].name]: otherColumn[data.details[0].name],
                  [`${data.details[0].name}Color`]: getColorFromString(
                    data.details[0].name
                  ),
                  [`${data.details[0].name}Id`]: `${data.details[0].id.toString()}`,
                };
              }
            }
          }

          filteredData = [...filteredData, current];
        }
      });

      let validGraphData =
        selectedFilterLot.filter((el) => el.id !== 1200).length > 0
          ? compressData(
              [...new Set(filteredData)].sort(function (a, b) {
                let aSum = 0;
                let bSum = 0;

                for (let i in a) {
                  if (typeof a[i] === 'number') {
                    aSum += a[i];
                  }
                }

                for (let j in b) {
                  if (typeof b[j] === 'number') {
                    bSum += b[j];
                  }
                }

                return bSum - aSum;
              }),
              'name',
              t
            )
          : formatData;

      setGraphData(validGraphData);

      let objectValues = validGraphData.reduce((acc, curr) => {
        Object.keys(curr).forEach((key) => {
          if (typeof curr[key] === 'number') {
            acc[key] = (acc[key] || 0) + curr[key];
          }
        });
        return acc;
      }, {});

      let sortedKeys = Object.entries(objectValues)
        .sort((a, b) => b[1] - a[1])
        .map((entry) => entry[0]);

      setKeys([...new Set(sortedKeys)]);
    }
  }, [
    dat.level,
    dat.sortedBy,
    selectedFilterLot,
    selectedZoneIdForGraph,
    surfaceRef,
  ]);

  const setMasterDatas = () => {
    const length = dat.dat.length;

    for (let index = 0; index < length; index += 1) {
      dat.dat[index].MasterDataEquipment = allGroups.type.find(
        (group) => group.id === dat.dat[index].ProjectSheet.MasterDataEquipmentId
      );
    }
  };

  const handleRedirectToGraph = (data) => {
    const currentSheet = dat.structureGraph.find(
      (structureGraph) => structureGraph[0] === parseInt(data.data[`${data.id}Id`])
    );

    const currentMasterData = dat.groups.find(
      (group) => group.id === currentSheet.sheets.ProjectSheet.MasterDataEquipment.id
    );

    const matchingAllotmentNode = globalDataInstance.allotmentNodes.get(
      currentSheet[0]
    );

    dat.updateFormValue('sheetToLifeCycle', currentSheet.sheets);
    dat.updateFormValue('nodeSearchValue', matchingAllotmentNode);
    dat.updateFormValue('allotSteps', currentSheet.details);
    dat.setSearchValue(currentMasterData);
    dat.setTabValue(0);
  };

  useEffect(() => {
    return () => {
      setKeys([]);
      setGraphData([]);
    };
  }, []);

  useEffect(() => {
    setMasterDatas();
  }, [dat]);

  if (graphData) {
    return (
      <>
        {isGraphEmpty ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexGrow: '1',
              fontSize: '30px',
              fontWeight: 'bold',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            {t('APP.REPORT.RESPONSIVEBAR.PH_A88560', {
              defaultValue: 'Pas de données',
            })}
          </div>
        ) : (
          <div style={{ margin: 5, height: '100%' }}>
            <HistogramVignetteComponent
              data={graphData}
              onClickBar={(e) =>
                dat.currentAllotment.id === ALLOTMENT_IDS.NOOCO ||
                typeof dat.level === 'string'
                  ? handleRedirectToGraph(e)
                  : null
              }
              style={{ height: '100%' }}
              keys={keys}
              isCustomProject={
                currentProject.templateType !== TEMPLATE_TYPE_NAME.NOOCO
              }
              isZoom={fullScreen}
              onClickFullscreen={graphToFullScreen}
              total={total}
              currentProject={currentProject}
            />
          </div>
        )}
      </>
    );

    // if sortedBy === 1, display graph for optimisation potentiel
  } else {
    return <div>Load</div>;
  }
};

const compressData = (data, level, t) => {
  let newData = [];

  data = data.filter((el) => el);

  for (let i in data) {
    if (i == 9) {
      newData.push(data[i]);

      for (let k in newData[9]) {
        if (newData[9][k] === level) {
          newData[9][k] = t('APP.REPORT.OTHERS', { defaultValue: 'Autres' });
        }
      }
    } else if (i > 9) {
      for (const [key, value] of Object.entries(data[i])) {
        newData[9][key] = value;
      }

      newData[newData.length - 1][level] = t('APP.REPORT.OTHERS', {
        defaultValue: 'Autres',
      });
    } else {
      newData.push(data[i]);
    }
  }

  return newData;
};
const computeResult = (
  sheet,
  refUnit,
  projectDdv,
  equipment,
  surfaceRef,
  sortedBy
) => {
  surfaceRef = refUnit === 'total' ? 1 : surfaceRef;

  let result = equipment.res / surfaceRef;

  if (sortedBy === 'potentiel') {
    result =
      (sheet.optiDelta * sheet.ProjectSheet.quantity * projectDdv) / 50 / surfaceRef;
  }

  return result;
};

export let exportFunctionsForTests = {};

if (process.env.NODE_ENV === 'test') {
  exportFunctionsForTests = {
    computeResult,
  };
}

export default ResponsiveBarGraph;
